export const ADDITIONAL_UNITS_PICKER = 'additional-units-picker';
export const CLICKED_LINK = 'clicked-link';
export const MODAL_INTERACTION = 'modal-interaction';